// Copyright 2016 Sorama B.V.

// Gradient background with SVG noise overlay, purely aesthetic, no functionality
export class GradientBackground {}
